<template>
  <th>
    <a href="#" class="has-text-info" @click.prevent="store.toggleSort(field)">
      <slot />
      <span class="sort-icon" :class="{ 'is-active': isActive }">{{ directionIcon }}</span>
    </a>
  </th>
</template>

<script setup>import { computed as _computed } from 'vue';

  /*
   * A table header that sorts a search list store (see create-search-list-store) by
   * `field`, clicking it again to flip the direction. The store owns the sort, so the
   * arrow reflects whatever it holds -- including a sort restored from the URL.
   *
   * <SortableHeader :store="store" field="shipped_at">Shipped</SortableHeader>
   *
   * `field` has to be one of the keys in the store's sort config; anything else falls
   * back to the default sort.
   */
  const props = defineProps({
    store: { type: Object, required: true },
    field: { type: String, required: true },
  });

  const isActive = _computed(() => props.store.sortBy === props.field);

  const directionIcon = _computed(() => {
    if (!isActive.value) return "⇅";
    return props.store.sortDirection === "asc" ? "↑" : "↓";
  });
</script>
